module.exports = "<app-states [hidden]=\"!state\" [state]=\"state\"></app-states>\n<ngx-loading [show]=\"loading\"></ngx-loading>"